import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { autorun } from 'mobx';

import './app.scss';

@inject('appStore', 'routerStore')
@observer
export class App extends Component {
    disabledCanHydrate = false;

    constructor(props) {
        super(props);
        const { appStore } = props;

        this.disposeSubmission = autorun(() => {
            if (appStore.submissionID && !appStore.dataLoaded) {
                appStore.retrieveSubmission();
            }
        });
    }

    componentWillUnmount() {
        this.disposeSubmission();
    }

    render() {
        const { children } = this.props;

        return (
            <div className='ht-app'>
                {children}
            </div>
        );
    }
}
